import { render, staticRenderFns } from "./YjDetail.vue?vue&type=template&id=41dc99a2&"
import script from "./YjDetail.vue?vue&type=script&lang=js&"
export * from "./YjDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports